import { createTable } from './createTable'
import { disableTable } from './disableTable'
import { enableTable } from './enableTable'
import { removeTable } from './removeTable'
import { table } from './table'
import { updateTable } from './updateTable'

export const tableService = {
  table,
  createTable,
  removeTable,
  updateTable,
  enableTable,
  disableTable,
}
